import React, { useState } from "react";
import { Colors } from "../../config/Constants";
import {
  ActionWrapper,
  Container,
  ErrorMessage,
  Header,
  RowWrapper,
  TextWrapper,
  ToggleWrapper,
} from "../../pages/EntryAccess";
import { entryAccessValidation } from "../../pages/EntryAccess/validation";
import Box from "../Box";
import Button from "../Button";
import Textfield from "../Textfield";
import Toggle from "../Toggle";

interface ReservationProps {
  postChangedData: any;
  setReservationAmount: any;
  reservationAmount: string;
  reservationToggle: boolean;
  setReservationToggle: any;
}

const Reservation = ({
  postChangedData,
  setReservationAmount,
  reservationAmount,
  setReservationToggle,
  reservationToggle,
}: ReservationProps) => {
  const [reservationAmountError, setReservationAmountError] = useState("");

  const handleReservationAmount = () => {
    let isValid = entryAccessValidation(
      reservationAmount,
      setReservationAmountError
    );
    if (isValid) {
      let data = {
        name: "Outlet reservation charge",
        amount: Number(reservationAmount),
        isActive: reservationToggle,
      };
      postChangedData("reservationfee", data);
    }
  };

  return (
    <div>
      <Header>Reservation</Header>
      <Box>
        <Container>
          <RowWrapper>
            <TextWrapper>
              <Textfield
                value={reservationAmount}
                placeholder={reservationAmount}
                label="Reservation Pre Payment Amount"
                variant="outlined"
                size="medium"
                onChange={(e) => {
                  setReservationAmount(e.target.value);
                  setReservationAmountError("");
                }}
                disabled={!reservationToggle}
                textColor={Colors.black}
                error={reservationAmountError ? true : false}
              />
              {reservationAmountError && (
                <ErrorMessage>{reservationAmountError}</ErrorMessage>
              )}
            </TextWrapper>
            <ActionWrapper>
              <ToggleWrapper>
                <Toggle
                  uniqueName="reservationfee"
                  isChecked={reservationToggle}
                  onChange={() => setReservationToggle(!reservationToggle)}
                />
              </ToggleWrapper>
              <div className="actionWrapper">
                <Button
                  variant="filled"
                  label="Save"
                  onClick={handleReservationAmount}
                  color={Colors.red}
                />
              </div>
            </ActionWrapper>
          </RowWrapper>
        </Container>
      </Box>
    </div>
  );
};

export default Reservation;
